export var redirectToCompletionUrl = function redirectToCompletionUrl(completionUrl) {
  window.location.href = completionUrl;
};